var _defs, _rect, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack188({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "15 15 8 1.35 1 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack188);
export default __webpack_public_path__ + "static/media/Symbolpack_1_88.64895b5e9638e862564abee22585a1cd.svg";
export { ForwardRef as ReactComponent };